const initialState = {
  addRoad: false,
  position: []
}

const AddRoad = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_ROAD_MODAL":
      return { ...state, addRoad: action.val }
    case "ADD_ROAD_MODAL_POINT":
      return { ...state, position: action.val ? [...state.position, ...action.val] : [] }
    default:
      return state
  }
}

export default AddRoad
